import React, { Component } from 'react';
import { IconButton } from '@mui/material';
import VideoBodyComponent from './VideoBodyComponent';
import { supportCategories, supportVideoList } from './VideoSupportList';
import "styles/sass/support/VideoSupportPage.scss";

class VideoSupportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCategory: "Pricing"
    };
  }

  handleCategoryChange = (category) => this.setState({ currentCategory: category });

  getVideoList = (category) => {
    const videoCategory = supportVideoList.find((item) => item.category === category)
    return videoCategory ? videoCategory.supportVideos : [];
  };

  render() {
    return (
      <section className="VideoSupportSection">
        <h1 className="videoPageTitle">Video Support</h1>
        <div className="icon-buttons-wraper">
          {supportCategories.map((data) => (
            <div key={data.category} className="icon-button-container">
              <IconButton
                className={this.state.currentCategory === data.category ? "current-icon-button" : ""}
                style={{ padding: 0, width: 90, height: 90 }}
                sx={{
                  width: data.category === 'Admin' ? 60 : 80,
                  height: data.category === 'Admin' ? 60 : 80,
                  color: "rgb(56 56 56)"
                }}
                onClick={() => this.handleCategoryChange(data.category)}
              >
                {data.icon}
              </IconButton>
              <span className="icon-label">{data.category}</span>
            </div>
          ))}
        </div>
        <VideoBodyComponent videos={this.getVideoList(this.state.currentCategory)} />
      </section>
    );
  }
}
export default VideoSupportPage;
